<script setup lang="ts">
import { computed } from "vue";
import { useTranslation } from "i18next-vue";
import UsersTable from "./UsersTable.vue";
import DRBtn from "../UI/DRBtn.vue";
import { useDeleteUser, useGetUsers, useToggleUser } from "@/stores/queries";
import OrganizationPageLayout from "@/components/organization/OrganizationPageLayout.vue";
import UserState from "@/stores/UserState";

const { t } = useTranslation();

const { data } = useGetUsers(true);

const users = computed(() => data.value ?? []);

const isAdmin = computed(
  () => UserState.data && ["ADMIN", "SUPERADMIN"].includes(UserState.data.role)
);

const { mutateAsync: mutateToggle } = useToggleUser();
const { mutateAsync: mutateDelete } = useDeleteUser();

const toggleUser = async (userId: number, organizationId?: number) => {
  mutateToggle({ id: userId, organizationId });
};
const deleteUser = async (userId: number, organizationId?: number) => {
  mutateDelete({ id: userId, organizationId });
};
</script>

<template>
  <OrganizationPageLayout
    :title="t('dashboard:navigation.members')"
    :description="t('dashboard:navigation.members-description')"
  >
    <template v-if="isAdmin" #actions>
      <RouterLink :to="{ name: 'settings-new-member' }">
        <DRBtn
          :label="t('dashboard:users.table.addButton')"
          icon="bi-plus-lg"
        />
      </RouterLink>
    </template>

    <UsersTable
      :users="users"
      :show-actions="isAdmin ?? false"
      @toggle="toggleUser($event)"
      @delete="deleteUser($event)"
    />
  </OrganizationPageLayout>
</template>
